import { BarChart3, Loader, ShieldCheck } from "lucide-react";

const WHAT_WE_READ = [
  "Sessions, users and pageviews",
  "Landing pages and bounce rate",
  "Acquisition channels",
  "Conversions (key events)",
  "Average engagement time",
];

/**
 * Pre-connection state: explains the scope before sending the user to Google.
 *
 * `reconnect` covers the case where a grant we already held stopped working — the copy has to say
 * why the dashboard vanished, not just offer a button.
 */
const ConnectCard = ({ onConnect, connecting = false, reconnect = false, error = null }) => (
  <div className="bg-surface-container-low rounded-2xl p-8 border border-surface-container-high max-w-2xl">
    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-5">
      <BarChart3 className="w-6 h-6 text-primary" />
    </div>

    <h2 className="font-headline text-xl font-bold text-on-surface">
      {reconnect ? "Reconnect Google Analytics" : "Connect Google Analytics"}
    </h2>
    <p className="text-sm text-on-surface-variant mt-2">
      {reconnect
        ? "Your Google Analytics connection is no longer valid — access was removed or expired. Reconnect to bring the dashboard back."
        : "See what your AI visibility actually delivers: traffic, landing pages, engagement and conversions, alongside the rest of your reports."}
    </p>

    <p className="text-xs font-semibold uppercase tracking-wide text-on-surface-variant mt-6 mb-3">
      What we read
    </p>
    <ul className="space-y-2">
      {WHAT_WE_READ.map((item) => (
        <li key={item} className="flex items-start gap-2 text-sm text-on-surface">
          <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
          {item}
        </li>
      ))}
    </ul>

    <div className="flex items-start gap-2 mt-6 text-xs text-on-surface-variant">
      <ShieldCheck className="w-4 h-4 shrink-0 mt-px text-primary" />
      <p>
        Read-only access. We request a single Google scope and can never change anything in your
        Analytics account. You can disconnect at any time.
      </p>
    </div>

    {error && <p className="text-sm text-error mt-5">{error}</p>}

    <button
      type="button"
      onClick={onConnect}
      disabled={connecting}
      className="mt-6 px-5 py-2.5 bg-primary text-on-primary rounded-xl text-sm font-bold hover:opacity-90 transition-opacity disabled:opacity-60 flex items-center gap-2"
    >
      {connecting && <Loader className="w-4 h-4 animate-spin" />}
      {reconnect ? "Reconnect Google Analytics" : "Connect Google Analytics"}
    </button>
  </div>
);

export default ConnectCard;
